import React from "react";
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/material";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import FmdBadIcon from "@mui/icons-material/FmdBad";
import {
  KeyboardDoubleArrowDown,
  KeyboardDoubleArrowUp,
} from "@mui/icons-material";
import { Badge } from "@mui/material";
import "../../../../static/styles/leak.css";

const LeakIcon = ({ status, severity, isSelected }) => {
  const theme = useTheme();
  const severityList = {
    1: { name: "minor", color: theme.palette.minor.main },
    2: { name: "moderate", color: theme.palette.moderate.main },
    3: { name: "major", color: theme.palette.major.main },
    4: { name: "remediated", color: theme.palette.remediated.main },
  };
  const status_list = {
    2: {
      name: "controlled",
      color: theme.palette.controlled.main,
      icon: <KeyboardDoubleArrowDown />,
    },
    3: {
      name: "escalating",
      color: theme.palette.escalating.main,
      icon: <KeyboardDoubleArrowUp />,
    },
  };

  let color =
    severityList[severity]?.color || theme.palette.primary.main;
  let arrowColor = status_list[status]?.color || "";

  return (
    <Box className={`leak-icon-status`}>
      <Badge
        badgeContent={status_list[status]?.icon}
        style={{ color: arrowColor }}
        variant="filled"
        className={`leak-icon-arrow ${isSelected ? "selected" : ""}`}
      >
        {severity === 3 ? (
          <FmdBadIcon
            style={{ color }}
            className={`${isSelected ? "selected" : ""}`}
          />
        ) : (
          <FmdGoodIcon
            className={`${isSelected ? "selected" : ""}`}
            style={{ color }}
          />
        )}
      </Badge>
    </Box>
  );
};

export default LeakIcon;
